import React from 'react';
import { List } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import findResult from '@/utils/resultsHelper';
import { newCohortFromDataset } from '@/cohorts/actions';
import datasetStatus from '../helper';
import DatasetStatusButtons from '../components/DatasetStatusButtons';
import { datasetIsEditing } from '../../helper';
import { primaryDictionary } from '../../dictionaries/state/state';
import { showDatasetConditions } from '../../conditions/actions';

const CatalogueStatusListItem = ({
  accessRequestAllowed,
  accessRequestSupported,
  accessRequestUnsupportedReasons,
  code,
  cohortAllowed,
  cohortSupported,
  cohortUnsupportedReasons,
  dictionaryCode,
  isEditing,
  hasConditions,
  name,
  newCohort,
  newCohortCode,
  newRequestCode,
  showConditions,
}) => {
  if (isEditing || (!accessRequestAllowed && !cohortAllowed)) {
    return null;
  }

  return (
    <List.Item className="aridhia-catalogue-status-list-item">
      <List.Header>
        <FormattedMessage id="table.header.status" />
      </List.Header>
      <List.Description className="aridhia-catalogue-status-list-item-description">
        <DatasetStatusButtons
          accessRequestAllowed={accessRequestAllowed}
          accessRequestSupported={accessRequestSupported}
          accessRequestUnsupportedReasons={accessRequestUnsupportedReasons}
          dictionaryCode={dictionaryCode}
          code={code}
          cohortAllowed={cohortAllowed}
          cohortSupported={cohortSupported}
          cohortUnsupportedReasons={cohortUnsupportedReasons}
          hasConditions={hasConditions}
          name={name}
          newCohort={newCohort}
          newCohortCode={newCohortCode}
          newRequestCode={newRequestCode}
          showConditions={showConditions}
          size="small"
          vertical
        />
      </List.Description>
    </List.Item>
  );
};

const mapStateToProps = ({
  auth: { role },
  cohorts: { newCohortCode },
  datasets: { datasets },
  requests: { newRequestCode },
}, { category, code }) => {
  const item = findResult(datasets, category, code);
  const dictionary = primaryDictionary(item, null);

  return {
    name: item.catalogue?.title,
    newCohortCode,
    newRequestCode,
    dictionaryCode: dictionary ? dictionary.code : null,
    isEditing: datasetIsEditing(item),
    ...datasetStatus(role, item, dictionary),
  };
};

const mapDispatchToProps = {
  newCohort: (code, datasetCode, dictionaryCode) => (
    newCohortFromDataset(code, 'open', datasetCode, [dictionaryCode])),
  showConditions: showDatasetConditions,
};

export default connect(mapStateToProps, mapDispatchToProps)(CatalogueStatusListItem);
